/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarycopyfailed3Inputs */

const en_medialibrarycopyfailed3 = /** @type {(inputs: Medialibrarycopyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't copy the link.`)
};

const de_medialibrarycopyfailed3 = /** @type {(inputs: Medialibrarycopyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Link konnte nicht kopiert werden.`)
};

/**
* | output |
* | --- |
* | "Couldn't copy the link." |
*
* @param {Medialibrarycopyfailed3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarycopyfailed3 = /** @type {((inputs?: Medialibrarycopyfailed3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarycopyfailed3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarycopyfailed3(inputs)
	return de_medialibrarycopyfailed3(inputs)
});
export { medialibrarycopyfailed3 as "mediaLibraryCopyFailed" }